import React, { FC } from 'react';
import styled from 'styled-components';
import { Colors } from '../../styles/colors';

const OverlayContainer = styled.div`
  position: fixed;
  z-index: 500;

  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  pointer-events: ${props => props['allowClickEvents'] ? 'none' : 'all'};
  background-color: ${props => props['colorBackground'] || Colors.primary};
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const Circle = styled.div`
  width: 2.125rem;
  height: 2.125rem;
  border-radius: 100%;
  background-color: ${props => props['colorForeground'] || Colors.white};

  @keyframes animation {
    from { opacity: 1 }
    to { opacity: 0}
  }

  animation-name: animation;
  animation-duration: 2s;
  animation-direction: alternate;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;

  &:last-child {
    animation-direction: alternate-reverse;
  }
`;

const MiddleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;

  width: 6.5rem;
  margin: 0 -1.075rem;
`;
const MiddleTop = styled.div`
  height: 1.075rem;
  background-image: radial-gradient(circle at 50% calc(4px - 30rem), rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0) 30rem, ${props => props['colorForeground'] || Colors.white} 30rem);
`;
const MiddleBottom = styled.div`
  height: 1.075rem;
  background-image: radial-gradient(circle at 50% calc(30rem + 1.075rem - 4px), rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0) 30rem, ${props => props['colorForeground'] || Colors.white} 30rem);
`;


interface Props {
  overlay?: boolean;
  transparent?: boolean;
}
export const LoadingAnimation: FC<Props> = (props) => {
  const { overlay = false, transparent = false } = props;

  const colors: any = {
    colorForeground: overlay && !transparent ? Colors.white : Colors.primary,
    colorBackground: transparent ? 'transparent' : Colors.primary,
  }

  const view = (
    <Container>
      <Circle {...colors} />
      <MiddleContainer>
        {/* <MiddleTop {...colors} />
        <MiddleBottom {...colors} /> */}
      </MiddleContainer>
      <Circle {...colors} />
    </Container>
  );

  if (overlay) {
    return (
      <OverlayContainer {...{...colors, allowClickEvents: transparent}}>
        { view }
      </OverlayContainer>
    )
  }
  return view;
};
